<app-header [forceLightBackground]="true"></app-header>
<div class="consumer-activities">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="consumer-activities--sidebar-col">
      <app-consumer-sidebar></app-consumer-sidebar>
    </div>
    <div class="consumer-activities--content flex-1 min-w-0">
      <app-page-header></app-page-header>
      <app-activities [showTabs]="true"></app-activities>
    </div>
  </div>
</div>
